import { Wrapper } from "../../components"
import axios from "axios"
import React, { useState,useEffect } from 'react'

const Fee = () => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);

    

    useEffect(() => {
        axios.get("https://gmskripto.com/fee/data.json").then((res) => {
            setData(res.data)
            setLoading(false)
        })
    }, [])

    if (loading) {
        return <div className="flex justify-center items-center h-screen">Loading...</div>
    }

    return (
        <Wrapper>
            <div className="max-w-7xl mx-auto px-4 py-12">
                {/* Trading Fees Section */}
                <div className="mb-16">
                    <h1 className="text-4xl font-bold text-surface-main mb-2">{data.tradingFees.title}</h1>
                    <p className="text-secondaryTwo mb-8">{data.tradingFees.description}</p>
                    
                    <div className="overflow-x-auto">
                        <table className="w-full">
                            <thead>
                                <tr className="border-b border-dark-line">
                                    <th className="py-4 px-6 text-left text-secondaryTwo">Seviye</th>
                                    <th className="py-4 px-6 text-left text-secondaryTwo">30 Günlük Hacim</th>
                                    <th className="py-4 px-6 text-left text-secondaryTwo">Maker Ücreti</th>
                                    <th className="py-4 px-6 text-left text-secondaryTwo">Taker Ücreti</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.tradingFees.tiers.map((tier, index) => (
                                    <tr key={index} className="border-b border-dark-line hover:bg-dark-backgroundOnDark transition-colors">
                                        <td className="py-4 px-6 text-surface-main">{tier.level}</td>
                                        <td className="py-4 px-6 text-surface-main">{tier.volume}</td>
                                        <td className="py-4 px-6 text-success">{tier.makerFee}%</td>
                                        <td className="py-4 px-6 text-success">{tier.takerFee}%</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* Withdrawal Fees Section */}
                <div>
                    <h2 className="text-4xl font-bold text-surface-main mb-2">{data.withdrawalFees.title}</h2>
                    <p className="text-secondaryTwo mb-8">{data.withdrawalFees.description}</p>
                    
                    <div className="overflow-x-auto">
                        <table className="w-full">
                            <thead>
                                <tr className="border-b border-dark-line">
                                    <th className="py-4 px-6 text-left text-secondaryTwo">Coin</th>
                                    <th className="py-4 px-6 text-left text-secondaryTwo">Ağ</th>
                                    <th className="py-4 px-6 text-left text-secondaryTwo">Çekim Ücreti</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.withdrawalFees.coins.map((coin, index) => (
                                    <tr key={index} className="border-b border-dark-line hover:bg-dark-backgroundOnDark transition-colors">
                                        <td className="py-4 px-6 text-surface-main">{coin.coin}</td>
                                        <td className="py-4 px-6 text-surface-main">{coin.network}</td>
                                        <td className="py-4 px-6 text-primary">{coin.fee}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </Wrapper>
    );
}

export { Fee }